import { getRequest } from 'utils/api/apiRequest'
import { WithPagination } from 'utils/api/pagination'
import { CatalogProduct } from 'utils/api/Products/CatalogProduct'

export const fetchRecentlyViewedProducts = () =>
  getRequest<WithPagination<CatalogProduct>>('/redemption-site/recently-viewed?limit=9')
